import { useQuery } from '@tanstack/react-query'
import type { IAdminDashboardMetrics } from '@brushfire/types'
import { platformClient } from '@/api/http/platformClient'
import { queryKeys } from '@/api/query-keys'
import type { ApiResponse } from '@/api/http/types'
import { useSessionStore } from '@/stores/useSessionStore'

const REFETCH_INTERVAL_MS = 30_000

async function fetchAdminDashboardMetrics(
  signal?: AbortSignal,
): Promise<IAdminDashboardMetrics> {
  const { data } = await platformClient.get<ApiResponse<IAdminDashboardMetrics>>(
    '/api/v1/admin-dashboard/metrics',
    { signal },
  )
  return data.data
}

function dashboardTenantKey(
  tenantId: string | null | undefined,
  subdomain: string | null | undefined,
): string {
  return tenantId ?? subdomain ?? '_'
}

export function useAdminDashboardMetrics() {
  const tenantId = useSessionStore((s) => s.user?.tenantId)
  const subdomain = useSessionStore((s) => s.user?.subdomain)
  const isAuthenticated = useSessionStore((s) => s.isAuthenticated)

  return useQuery({
    queryKey: queryKeys.adminDashboard.metrics(
      dashboardTenantKey(tenantId, subdomain),
    ),
    queryFn: ({ signal }) => fetchAdminDashboardMetrics(signal),
    enabled: isAuthenticated,
    refetchInterval: REFETCH_INTERVAL_MS,
  })
}
